var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    enableBackground: "new 0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#972679",
    d: "M187.14,292.19c-28.66-3.17-42.83-14.66-49.32-42.99c-7.83-34.49-9-69.49,5.17-102.65 c13.83-32.66,44.83-34.66,72.49-22.66c10,4.33,16.83,17.33,20.16,28.83c11.5,38.16,11.33,76.49-3.5,113.98 c-1.5,3.67-3.17,6.5-5.83,9c-2.5,2.33-4.83,4.67-7.33,7c-1.5,1.17-7.83,4.83-9.33,5.33c-1.17,0.5-6.33,2.33-9.33,3 c-1.83,0.33-3.5,0.5-5.33,0.83C192.3,292.02,189.8,292.02,187.14,292.19z M165.81,205.53c0.5,12,0,27.16,4.5,41.99 c2.83,9.16,8.67,14.5,18.5,14.5c9.33,0,14.83-5.5,17-14.16c6.83-28.16,6.67-56.66,0.5-84.98c-2.17-9.83-7.83-16-18.5-15.83 c-10.66,0.17-15.66,7.33-18.16,16.66C166.31,176.37,165.97,189.37,165.81,205.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#972679",
    d: "M320.94,116.22C320.94,116.22,321.11,116.22,320.94,116.22c37.33,9.5,52.16,22,54.99,60.66 c1.67,22.5,2,44.66-3.67,66.49c-10.66,40.49-53.16,60.66-84.98,37.49c-9.16-6.67-14.5-15.66-17.33-26.16 c-8.67-31.16-8.33-62.66-1.83-93.98c5.17-25.16,20.33-41.16,46.99-44.16C317.61,116.22,318.78,116.05,320.94,116.22z  M340.61,204.87c-1.17-13.83,0.67-27.83-3.5-41.49c-3-9.83-8.17-17.83-19.16-17.16c-11.33,0.67-16.33,9-18.5,19.66 c-4.33,22.16-3,44.49-1.83,66.82c0.33,6,2.83,12,4.83,17.83c2.67,7.67,8.67,10.83,16.66,10.83c8.33,0,12.66-4.5,16-11.83 C341.77,235.2,339.11,219.7,340.61,204.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#972679",
    d: "M21.5,184.54c11.5-4.83,19-5.67,27.49-15.16c2.67-3.67,5.33-4.17,5.17,1.17c-0.83,22-0.83,43.33-1.17,65.82 c0,8,0.33,14.83,0,22.83c-0.33,6.83,0,12-0.33,21c0,0.17,0,0.5,0,0.67c0.5,3.5,2.33,5.83,5.67,6.83c0.33,0.17,0.67,0.17,1.17,0.17 c8.17,0,15.33-0.5,22.66-0.33l0,0c1.67,0,3.17-1.5,3.17-3.17c0.17-2.67,0.5-7.83,0.5-9c0.33-48.82,0.67-97.65,1-146.31 c0-4.17,1.67-9.16-3.5-12c-6.83-3.5-22.16,0.83-27,7.67c-9,13-32.16,24.33-32.33,24.33c-1,0.5-2,1.17-3.17,1.67L21.5,184.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.9999,
    y1: 228.1265,
    x2: 16.9999,
    y2: 228.1265,
    gradientTransform: "matrix(1 0 0 -1 0 402.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    style: {
      stopColor: "#F60E71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#972679"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M17,174.37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.4312,
    y1: 115.8138,
    x2: 213.6638,
    y2: 115.8138,
    gradientTransform: "matrix(1 0 0 -1 0 402.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    style: {
      stopColor: "#F60E71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#972679"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M209.46,287.52c1.5-0.5,2.83-1.17,4.17-1.67C212.3,286.35,210.8,286.85,209.46,287.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.9999,
    y1: 228.1265,
    x2: 16.9999,
    y2: 228.1265,
    gradientTransform: "matrix(1 0 0 -1 0 402.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    style: {
      stopColor: "#F60E71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#972679"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M17,174.37"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg100);
export default __webpack_public_path__ + "static/media/100.239aa15646cfba4444e082c34ef185c6.svg";
export { ForwardRef as ReactComponent };